module.exports = __webpack_public_path__ + "static/img/testimonial-bg.2503459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/testimonial-bg.png
// module id = Y3RR
// module chunks = 36